/**
 * Az árajánlat adatok kulcsai dokumentum generáláshoz
 * 
 * Az összes lehetséges placeholder, amit az árajánlat dokumentumaiban használni lehet
 */
export const quotationKeys = {
  'Ajánlat száma': '',
  'Szerződés száma': '',
  'Cég megnevezése': '',
  'Cég címe': '',
  'Cég adószáma': '',
  'Cégjegyzékszám': '',
  'Képviselő neve': '',
  'Kapcsolattartó neve': '',
  'Dátum': '',
  'Ajánlat érvényessége': '',
  'Fizetési határidő': '',
  'Fogyasztás kWh': '',
  'Szerződés kezdete': '',
  'Szerződés vége': '',
  'Ajánlati ár': '',
  'Szerződéses ár': '',
  'Ár egység': '',
  'Fogyasztás': '',
  'Ajánlati ár HUF/kWh-EUR/MWh': '',
  'KÁT': '',
  'KÁT szöveg': '',

  // Dinamikus POD táblázat
  'POD_TABLE': '',

  'POD': '',
  'Fogy.hely cím': '',
  'Távmért / Profilos': '',
  'Mérő típusa': '', // AMR vagy SLP
  'Teljesítmény (kW)': '',
  'Profil- szám': '',
  'MÉF / Éves mennyiség (kWh)': '',

  // További POD-ok
  'POD 2': '',
  'Fogy.hely cím 2': '',
  'Távmért / Profilos 2': '',
  'Mérő típusa 2': '', // AMR vagy SLP
  'Teljesítmény (kW) 2': '',
  'Profil- szám 2 ': '',
  'MÉF 2 / Éves mennyiség (kWh)': '',

  'POD 3': '',
  'Fogy.hely cím 3': '',
  'Távmért / Profilos 3': '',
  'Mérő típusa 3': '',
  'Teljesítmény (kW) 3': '',
  'Profil- szám 3': '',
  'MÉF 3 / Éves mennyiség (kWh)': '',

  'POD 4': '',
  'Fogy.hely cím 4': '',
  'Távmért / Profilos 4': '',
  'Mérő típusa 4': '',
  'Teljesítmény (kW) 4': '',
  'Profil- szám 4': '',
  'MÉF 4 / Éves mennyiség (kWh)': '',

  'POD 5': '',
  'Fogy.hely cím 5': '',
  'Távmért / Profilos 5': '',
  'Mérő típusa 5': '',
  'Teljesítmény (kW) 5': '',
  'Profil- szám 5': '',
  'MÉF 5 / Éves mennyiség (kWh)': '',

  'POD 6': '',
  'Fogy.hely cím 6': '',
  'Távmért / Profilos 6': '',
  'Mérő típusa 6': '',
  'Teljesítmény (kW) 6': '',
  'Profil- szám 6': '',
  'MÉF 6 / Éves mennyiség (kWh)': '',
  
  // További POD-ok (7-20)
  'POD 7': '',
  'Fogy.hely cím 7': '',
  'Távmért / Profilos 7': '',
  'Mérő típusa 7': '',
  'Teljesítmény (kW) 7': '',
  'Profil- szám 7': '',
  'MÉF 7 / Éves mennyiség (kWh)': '',

  'POD 8': '',
  'Fogy.hely cím 8': '',
  'Távmért / Profilos 8': '',
  'Mérő típusa 8': '',
  'Teljesítmény (kW) 8': '',
  'Profil- szám 8': '',
  'MÉF 8 / Éves mennyiség (kWh)': '',

  'POD 9': '',
  'Fogy.hely cím 9': '',
  'Távmért / Profilos 9': '',
  'Mérő típusa 9': '',
  'Teljesítmény (kW) 9': '',
  'Profil- szám 9': '',
  'MÉF 9 / Éves mennyiség (kWh)': '',

  'POD 10': '',
  'Fogy.hely cím 10': '',
  'Távmért / Profilos 10': '',
  'Mérő típusa 10': '',
  'Teljesítmény (kW) 10': '',
  'Profil- szám 10': '',
  'MÉF 10 / Éves mennyiség (kWh)': '',

  'POD 11': '',
  'Fogy.hely cím 11': '',
  'Távmért / Profilos 11': '',
  'Mérő típusa 11': '',
  'Teljesítmény (kW) 11': '',
  'Profil- szám 11': '',
  'MÉF 11 / Éves mennyiség (kWh)': '',

  'POD 12': '',
  'Fogy.hely cím 12': '',
  'Távmért / Profilos 12': '',
  'Mérő típusa 12': '',
  'Teljesítmény (kW) 12': '',
  'Profil- szám 12': '',
  'MÉF 12 / Éves mennyiség (kWh)': '',

  'POD 13': '',
  'Fogy.hely cím 13': '',
  'Távmért / Profilos 13': '',
  'Mérő típusa 13': '',
  'Teljesítmény (kW) 13': '',
  'Profil- szám 13': '',
  'MÉF 13 / Éves mennyiség (kWh)': '',

  'POD 14': '',
  'Fogy.hely cím 14': '',
  'Távmért / Profilos 14': '',
  'Mérő típusa 14': '',
  'Teljesítmény (kW) 14': '',
  'Profil- szám 14': '',
  'MÉF 14 / Éves mennyiség (kWh)': '',

  'POD 15': '',
  'Fogy.hely cím 15': '',
  'Távmért / Profilos 15': '',
  'Mérő típusa 15': '',
  'Teljesítmény (kW) 15': '',
  'Profil- szám 15': '',
  'MÉF 15 / Éves mennyiség (kWh)': '',

  'POD 16': '',
  'Fogy.hely cím 16': '',
  'Távmért / Profilos 16': '',
  'Mérő típusa 16': '',
  'Teljesítmény (kW) 16': '',
  'Profil- szám 16': '',
  'MÉF 16 / Éves mennyiség (kWh)': '',

  'POD 17': '',
  'Fogy.hely cím 17': '',
  'Távmért / Profilos 17': '',
  'Mérő típusa 17': '',
  'Teljesítmény (kW) 17': '',
  'Profil- szám 17': '',
  'MÉF 17 / Éves mennyiség (kWh)': '',

  'POD 18': '',
  'Fogy.hely cím 18': '',
  'Távmért / Profilos 18': '',
  'Mérő típusa 18': '',
  'Teljesítmény (kW) 18': '',
  'Profil- szám 18': '',
  'MÉF 18 / Éves mennyiség (kWh)': '',

  'POD 19': '',
  'Fogy.hely cím 19': '',
  'Távmért / Profilos 19': '',
  'Mérő típusa 19': '',
  'Teljesítmény (kW) 19': '',
  'Profil- szám 19': '',
  'MÉF 19 / Éves mennyiség (kWh)': '',

  'POD 20': '',
  'Fogy.hely cím 20': '',
  'Távmért / Profilos 20': '',
  'Mérő típusa 20': '',
  'Teljesítmény (kW) 20': '',
  'Profil- szám 20': '',
  'MÉF 20 / Éves mennyiség (kWh)': ''
};

